import React, { useMemo } from 'react';

import Typography from 'components/uiLibrary/Typography';

import { getProductionDateParts } from 'utils/productions';
import { useTranslation } from 'src/i18n';

import classes from './DateRangeAndPrefCount.module.scss';

const DateRangeAndPrefCount = ({ production }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');

  const startEndDate = useMemo(() => getProductionDateParts(production), [production]);

  return (
    <div className={classes.dateRangeCount}>
      <Typography className={classes.date} weight="bold" size={16}>
        {startEndDate?.dates} {startEndDate?.years}
      </Typography>
      {production?.performances?.length > 0 && (
        <Typography className={classes.totalPref}>
          ({production.performances.length} {t(`PERFORMANCES`)})
        </Typography>
      )}
    </div>
  );
};

export default DateRangeAndPrefCount;
